import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(public storage: Storage) {
    this.storage.create();
  }

  public getFromLocalStorage(key:string){
    return this.storage.get(key);
  }

  public setLocalStorage(key:string,val:any){
    this.storage.set(key, val);
  }

}
